import {
  AzureIcon,
  BitBucketIcon,
  GithubIcon,
  GitlabIcon,
  UnknownRepoIcon,
} from 'assets';
import React from 'react';

const RepoTypeIcon = ({ repoType, size }) => {
  let iconSource;
  let altText = '';

  // Determine icon source and alt text based on repoType
  switch (repoType.toLowerCase()) {
    case 'azure':
      iconSource = AzureIcon;
      altText = 'Azure DevOps';
      break;
    case 'github':
      iconSource = GithubIcon;
      altText = 'Github';
      break;
    case 'gitlab':
      iconSource = GitlabIcon;
      altText = 'GitLab';
      break;
    case 'bitbucket':
      iconSource = BitBucketIcon;
      altText = 'Bitbucket';
      break;
    default:
      // If repoType is not recognized, set a default icon
      iconSource = UnknownRepoIcon;
      altText = 'Unknown Repo Type';
  }

  // Return the appropriate icon or a default icon
  return repoType === 'other' ? (
    <i
      className="fa fa-plug"
      style={{
        color: '#0e74bc',
        fontSize: `${size}px`,
      }}
    ></i>
  ) : (
    <img width={size} height={size} src={iconSource} alt={altText} />
  );
};

export default RepoTypeIcon;
